import { ProductCategoryEnum } from "web_myplann/Infrastructure/Api/Api";

/**
 * Maps `PortfolioDetailResponseDTO.productCategoryId` to the string-backed
 * `ProductCategoryEnum`. The backend enum is int-backed; this ID list mirrors
 * `api_myplann/moduleApi/Portfolio/Enum/ProductCategoryEnum.php` and must be
 * kept in sync with it.
 */
const productCategoryById: Record<number, ProductCategoryEnum> = {
	33: ProductCategoryEnum.ConsumerLoans,
	34: ProductCategoryEnum.VehicleInsurance,
	35: ProductCategoryEnum.PropertyAndLiabilityInsurance,
	36: ProductCategoryEnum.BusinessPropertyAndLiabilityInsurance,
	37: ProductCategoryEnum.TravelInsurance,
	38: ProductCategoryEnum.InvestmentFunds,
	39: ProductCategoryEnum.CurrentAndSavingsAccounts,
	40: ProductCategoryEnum.InvestmentBonds,
	41: ProductCategoryEnum.AccidentInsurance,
	42: ProductCategoryEnum.HealthInsuranceForeigners,
	43: ProductCategoryEnum.FleetInsurance,
	44: ProductCategoryEnum.LifeInsuranceWithoutReserve,
	45: ProductCategoryEnum.LifeInsuranceWithReserve,
	46: ProductCategoryEnum.TermDeposit,
	48: ProductCategoryEnum.PensionTransformedFund,
	49: ProductCategoryEnum.PensionSupplementarySavings,
	50: ProductCategoryEnum.BusinessLoans,
	51: ProductCategoryEnum.HousingLoans,
	52: ProductCategoryEnum.CreditCard,
	53: ProductCategoryEnum.Leasing,
	54: ProductCategoryEnum.CommoditiesOneTime,
	55: ProductCategoryEnum.CommoditiesRegular,
	56: ProductCategoryEnum.BuildingSavingsLoan,
	57: ProductCategoryEnum.BuildingSavings,
	58: ProductCategoryEnum.LifeInsuranceCombinedReserve,
	59: ProductCategoryEnum.PensionInsurance,
	60: ProductCategoryEnum.InvestmentCombined,
	61: ProductCategoryEnum.RealEstate,
	62: ProductCategoryEnum.Energy,
	63: ProductCategoryEnum.OtherLoans,
	64: ProductCategoryEnum.TrustManagement,
	65: ProductCategoryEnum.Cryptocurrencies,
	67: ProductCategoryEnum.CurrencyExchange,
};

/** Resolves a `productCategoryId` to its `ProductCategoryEnum`, or null when unknown/missing. */
export const resolveProductCategory = (
	productCategoryId: number | null | undefined,
): ProductCategoryEnum | null =>
	productCategoryId != null
		? (productCategoryById[productCategoryId] ?? null)
		: null;
